<template>
  <ul class="selectable-list arena-list-container">
    <ArenasTreeItem  v-for="arena in arenas" :key="arena.id" :arena="arena" :selectedArena="selectedArena" v-on:choseArena="onChooseArena">
    </ArenasTreeItem>
</ul>
</template>
<script>
  import ArenasTreeItem from './ArenasTreeItem.vue'
  export default {
    name: 'ArenasTree',
    components: {ArenasTreeItem},
    props: {
      arenas: Array
    },
    data: function () {
      return {
        selectedArena: null
      }
    },
    methods: {
      onChooseArena: function (arena) {
        this.$emit('choseArena', arena)
        this.selectedArena = arena
      }
    }
  }
</script>

<style scoped>
  .item {
    cursor: pointer;
  }
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: dot;
  }
</style>
